/* Document Level Styles */

/*
  The imports below are needed to include our light dom css for global styles such as fonts and colors.
  You can comment out any of these imports if you do not need that css. For example, if you have your own
  global font family css then you can comment out the typography.css import.
*/

/** Core CSS required for ionic components to work property */
@import '~@ionic/core/css/core.css';

/** Basic CSS for apps built with Ionic */
@import '~@ionic/core/css/normalize.css';
@import '~@ionic/core/css/structure.css';
@import '~@ionic/core/css/typography.css';

/** Optional CSS utils that can be commented out */
@import '~@ionic/core/css/padding.css';
@import '~@ionic/core/css/float-elements.css';
@import '~@ionic/core/css/text-alignment.css';
@import '~@ionic/core/css/text-transformation.css';
@import '~@ionic/core/css/flex-utils.css';

/*
  The CSS Variables below can be used to theme your app.
  For more info on CSS variables check out:
  https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_variables

  More info about color theming using Ionic:
  https://ionicframework.com/docs/theming/color-generator
*/

.code {
    background-color: black;
    color: orange;
}

.form-values {
    position: fixed;
    max-width: 500px;
    max-height: 100%;
}

.scrollable {
    max-height: 600px;
    overflow-y: scroll;
}
